<template>
  <div class="foot_box">
    <!-- <el-row class="link">
            <ul class="clearfloat">
                <li><router-link :to="{path:'/content?flag=GYBXT'}">关于本系统</router-link></li>
                <li class="footer_line"></li>
                <li><router-link :to="{path:'/content?flag=LXWM'}">联系我们</router-link></li>
                <li class="footer_line"></li>
                <li><router-link :to="{path:'/content?flag=FLSM'}">法律声明</router-link></li>
            </ul>
          
        </el-row>
        <el-row>
            <p>广播电视节目制作经营许可证181号 信息网络传播视听节目许可证号0110486 京卫网审[2012]第0051号 国家药监局（京）-经营性-2011-0014</p>
            <p>京网文（2016）6683-919号 京ICP证101021号 京公网安110402440033号</p>
        </el-row>
        <el-row>
            <p>copyright &copy; {{this.$store.state.sysname}}</p>
    </el-row>-->
    <div class="main">
      <el-row>
        <el-col :span="6" style="display:flex;flex-direction:row;">
          <el-image style="width:42px;height:42px;vertival-align:middle;" :src="logoSrc"></el-image>
          <div
            style="vertical-align:middle;margin:auto 20px;font-size:30px;font-weight:bold;text-align:left;"
          >中国文联</div>
        </el-col>

        <el-col :span="18">
          <div style="text-align:left;border-left:2px solid #b2b9c0;padding:20px 30px; ">
            <!-- <div>
              <div>Copyright &copy;2019 WENYIZIYUANZHONGXIN Corporation,All Rights Reserved</div>
              <div>中国文联视频资源数据展示应用平台 版权所有 京ICP备 xxxxx号</div>
            </div>
            <div style="margin-top:20px;">
              <div>Copyright &copy; LITERARY AND RESOURCE CENTER.CFLAC</div>
              <div>中国文联网络文艺传播中心</div>
            </div> -->
            <div v-html="content">

            </div>
          </div>
        </el-col>
      </el-row>

      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  data:function() {
    return {
      logoSrc: require("../../assets/img/logo2.png"),
      content:''
    };
  },
  methods: {
    getByCode:async function(){
      var res = await this.$http.get(`/v1/message/getByCode?code=Footer`)
      var {code,message,data} = res.data
      if(code == 0){
        this.content = data.content
      }
    }
  },
  mounted() {
    this.getByCode();
  },
  watch: {}
};
</script>

<style lang="scss">
// ------
// .foot_box{
//     height: 213px;
//     background-color: #1d2935;
//     padding: 50px;
//     margin-top: 30px;
//     text-align: center;
//     position: static;
//     bottom: 10px;
//     min-width: 200px;
//     .footer_line{
//         width: 1px;
//         height: 12px;
//         background-color:  #787878;
//         margin-top: 10px;
//     }
//     ul{
//         height: 30px;
//         line-height: 30px;
//         display: inline-block;
//         li{
//             float: left;
//             margin: 0 10px;
//             a{
//                 font-size: 14px;
//             }
//         }
//     }
//     p{
//         color: #c7c7c7;
//         font-size: 14px;
//     }
// }
// --------
// 改版后的底部样式
.foot_box {
  width: 100%;
  height: 213px;
  background-color: #1d2935;
  padding: 50px;
  margin-top: 30px;
  text-align: center;
  position: relative;
  color: #b2b9c0;
  bottom: 0px;
  min-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue